/** Park Mode 协议版本控制所需的最低 Shark 设备系统版本 */
export const PARK_MODE_AGREEMENT_VERSION_MIN = '1.9.85';

/**
 * 将版本字符串解析为数字段（忽略段后非数字后缀，如 `1.9.85rc2` → `[1,9,85]`）。
 * @param version - 原始版本号
 * @returns 数字段数组；无法解析时返回空数组
 */
function parseVersionSegments(version: string): number[] {
    /** 去首尾空白后的版本串 */
    const trimmed = String(version ?? '').trim();
    if (!trimmed) {
        return [];
    }
    return trimmed.split('.').map((part) => {
        /** 段内连续数字前缀 */
        const match = part.match(/^(\d+)/);
        if (!match) {
            return 0;
        }
        return Number.parseInt(match[1], 10);
    });
}

/**
 * 判断当前设备系统版本是否大于等于最低要求版本（按 major.minor.patch 数字段比较）。
 * 空串或无法解析的 current → false。
 * @param current - `latest_device_system_version` 等原始版本
 * @param min - 最低要求版本，默认 {@link PARK_MODE_AGREEMENT_VERSION_MIN}
 */
export function isDeviceSystemVersionAtLeast(
    current: string | null | undefined,
    min: string = PARK_MODE_AGREEMENT_VERSION_MIN,
): boolean {
    /** 当前版本数字段 */
    const currentParts = parseVersionSegments(String(current ?? ''));
    if (currentParts.length === 0) {
        return false;
    }
    /** 最低要求数字段 */
    const minParts = parseVersionSegments(min);
    if (minParts.length === 0) {
        return false;
    }
    /** 对齐比较长度 */
    const len = Math.max(currentParts.length, minParts.length);
    for (let i = 0; i < len; i += 1) {
        /** 当前段（缺省为 0） */
        const a = currentParts[i] ?? 0;
        /** 最低段（缺省为 0） */
        const b = minParts[i] ?? 0;
        if (a > b) {
            return true;
        }
        if (a < b) {
            return false;
        }
    }
    return true;
}
